import { Link } from "react-router-dom"

const Header = () =>
<header className="d-flex text-bg-vc py-3">
    <div className="container">
        <div className="row">
            <div className="col-5 col-lg-2">
        <a href="/">
            <h1 className="invisible h0">Voice Coach for Podcast in Sydney</h1>
            <img src="/img/logo.svg" className="w-75" alt="Voice Coach logo" />
        </a>
        </div>
        <div className="col-7 offset-lg-3 col-lg-7 d-flex">
        <nav className="navbar navbar-expand-lg">
            <ul role="navigation" className="navbar-nav md-align-items-center">
                <li className="nav-item mx-4 py-1">
                    <Link to="/">Home</Link>
                </li>
                <li className="nav-item mx-4 py-1">
                    <Link to="/course-details">Course Details</Link>
                </li>
                <li className="nav-item mx-4 py-1">
                    <Link to="/about-you">About You</Link>
                </li>
                <li className="nav-item mx-4 py-1">
                    <Link to="/about">About Us</Link>
                </li>
                <li className="nav-item mx-4 py-1">
                    <Link to="/booking">Start Learning</Link>
                </li>
            </ul>
        </nav>
        </div>
        </div>
    </div>
</header>
export default Header